import { Dispatch, SetStateAction } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import { LocalStorageKey } from '../enums/LocalStorageKey'

export function useStorage<T>(
  key: LocalStorageKey,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>] {
  return useLocalStorage(key, initialValue)
}
